import { Record, Union } from "../fable_modules/fable-library-js.4.19.0/Types.js";
import { record_type, array_type, int32_type, bool_type, union_type, obj_type } from "../fable_modules/fable-library-js.4.19.0/Reflection.js";
import * as NotificationScripts from "./NotificationScripts.js";
import { uncurry2, defaultOf, equals } from "../fable_modules/fable-library-js.4.19.0/Util.js";
import { Encoders, sendJson, errorString } from "../../Bfs.Web.Portale/./Http.fs.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../fable_modules/Thoth.Json.10.4.1/./Encode.fs.js";
import { Notifications_EndpointIdentifier_$reflection, Notifications_EndpointIdentifier, Notifications_Subscription_$reflection } from "../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.7.0/Fetch.fs.js";
import { singleton } from "../fable_modules/fable-library-js.4.19.0/List.js";
import { Auto_generateBoxedDecoderCached_Z6670B51 } from "../fable_modules/Thoth.Json.10.4.1/./Decode.fs.js";
import { CaseStrategy } from "../fable_modules/Thoth.Json.10.4.1/Types.fs.js";
import { fromString } from "../../Bfs.Web.Portale/../Bfs.Web.Kundenportal/fable_modules/Thoth.Json.10.4.1/Decode.fs.js";

export class ServiceWorkerRegistration extends Union {
    constructor(Item) {
        super();
        this.tag = 0;
        this.fields = [Item];
    }
    cases() {
        return ["ServiceWorkerRegistration"];
    }
}

export function ServiceWorkerRegistration_$reflection() {
    return union_type("Bfs.Web.Kundenportal.PWA.NotificationBindings.ServiceWorkerRegistration", [], ServiceWorkerRegistration, () => [[["Item", obj_type]]]);
}

export class SubscriptionProperties extends Record {
    constructor(userVisibleOnly, applicationServerKey) {
        super();
        this.userVisibleOnly = userVisibleOnly;
        this.applicationServerKey = applicationServerKey;
    }
}

export function SubscriptionProperties_$reflection() {
    return record_type("Bfs.Web.Kundenportal.PWA.NotificationBindings.SubscriptionProperties", [], SubscriptionProperties, () => [["userVisibleOnly", bool_type], ["applicationServerKey", array_type(int32_type)]]);
}

export const NotificationPermissionGranted = "granted";

export const NotificationPermissionDenied = "denied";

function NotificationHelper_GetSubscription() {
    const pr_4 = NotificationScripts.serviceWorkerRegistration;
    return pr_4.then((registration) => {
        let pr_3;
        const pr_2 = NotificationScripts.getSubscription(registration);
        pr_3 = (pr_2.then((subscription) => {
            if (equals(subscription, defaultOf())) {
                let pr_1;
                const response = fetch("/api/notification/vapidPublicKey", {
                    credentials: "include",
                });
                pr_1 = (response.then((response_1_1) => {
                    if (!(response_1_1.ok)) {
                        throw new Error(errorString(response_1_1));
                    }
                    else {
                        return response_1_1.text();
                    }
                }));
                return pr_1.then((vapidPublicKey) => NotificationScripts.subscribe(registration, vapidPublicKey));
            }
            else {
                return Promise.resolve(subscription);
            }
        }));
        return pr_3.then((arg_2) => NotificationScripts.mapSubscription(arg_2));
    });
}

export function NotificationHelper_SubscribeToWebPush() {
    let pr_1;
    const pr = NotificationHelper_GetSubscription();
    pr_1 = (pr.then((body) => sendJson("/api/notification/saveSubscription", toString(0, Auto_generateBoxedEncoder_437914C6(Notifications_Subscription_$reflection(), undefined, undefined, undefined)(body)), singleton(new Types_RequestProperties(4, ["include"])), "POST")));
    return pr_1.then((_arg) => (_arg.ok));
}

export function NotificationHelper_UnsubscribeFromWebPush() {
    let pr_2;
    const pr = NotificationHelper_GetSubscription();
    pr_2 = (pr.then((sub) => (new Notifications_EndpointIdentifier(sub.Endpoint))));
    return pr_2.then((body) => {
        const response = sendJson("/api/notification/disable", toString(0, Auto_generateBoxedEncoder_437914C6(Notifications_EndpointIdentifier_$reflection(), undefined, undefined, undefined)(body)), singleton(new Types_RequestProperties(4, ["include"])), "POST");
        const decoder = Auto_generateBoxedDecoderCached_Z6670B51(bool_type, new CaseStrategy(1, []), Encoders());
        return response.then((response_1_1) => {
            if (!(response_1_1.ok)) {
                throw new Error(errorString(response_1_1));
            }
            else {
                const pr_1 = response_1_1.text();
                return pr_1.then((res) => {
                    const matchValue = fromString(uncurry2(decoder), res);
                    if (matchValue.tag === 1) {
                        throw new Error(matchValue.fields[0]);
                    }
                    else {
                        return matchValue.fields[0];
                    }
                });
            }
        });
    });
}

//# sourceMappingURL=NotificationBindings.fs.js.map
